import { TextInput } from 'components/_form-elements/TextInput/TextInput';
import { Button } from 'components/_universal/Button/Button';
import { DefaultText } from 'components/_universal/Typography.styled';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const PageWrapper = styled.div(
    ({ theme: { colors } }) => css`
        align-items: center;
        background-color: ${colors.app_bg};
        color: ${colors.text};
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: 100vh;
        padding: 110px 0 40px;
        position: relative;
        width: 100%;
        z-index: 1;
    `,
);

export const PageBox = styled.div(
    () =>
        css`
            display: flex;
            flex-direction: column;
            max-width: 314px;
            z-index: 10;
        `,
);

export const Logo = styled.img`
    height: 47px;
    width: 283px;
    z-index: 10;
`;

export const StyledLink = styled(Link)`
    margin-bottom: 20%;
    z-index: 10;
`;

export const WaveWrapper = styled.img`
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1;
`;

export const FormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    min-width: 314px;
    width: 100%;
`;

export const StyledInput = styled(TextInput)``;

export const StyledButton = styled(Button)(
    () => css`
        margin: 18px 0;
        text-transform: uppercase;
    `,
);

export const StyledGoogleButton = styled(Button)`
    display: flex;
    justify-content: center;
    margin: 18px 0;
    padding: 10px 32px;
`;

export const AnotherText = styled(DefaultText)(
    ({ theme: { colors, fontFamily } }) =>
        css`
            color: ${colors.text};
            display: flex;
            font-family: ${fontFamily.secondary};
            justify-content: center;
            margin: 10px 0;
            position: relative;
            width: fit-content;
            align-self: center;

            &:before,
            &:after {
                background-color: ${colors.text};
                content: '';
                height: 1px;
                position: absolute;
                top: 7px;
                width: 36%;
            }
            &:after {
                right: -40%;
            }
            &:before {
                left: -40%;
            }
        `,
);

export const Text = styled(DefaultText)(
    ({ theme: { colors, fontFamily, fontSizes } }) =>
        css`
            align-self: center;
            color: ${colors.text};
            display: flex;
            font-family: ${fontFamily.secondary};
            font-size: ${fontSizes.f14};
            justify-content: center;
            margin: 20px 0;
            position: relative;
        `,
);

export const SecondaryText = styled(DefaultText)(
    ({ theme: { colors, fontFamily, fontSizes } }) =>
        css`
            align-self: center;
            color: ${colors.text};
            font-family: ${fontFamily.secondary};
            font-size: ${fontSizes.f14};
            justify-content: center;
            margin-bottom: 30px;
            position: relative;
            text-transform: none;
        `,
);

export const LinkWrapper = styled(Link)(
    ({ theme: { colors, fontFamily, fontWeight } }) =>
        css`
            color: ${colors.text};
            font-family: ${fontFamily.secondary};
            text-decoration: none;
            margin: 0 4px;
            font-weight: ${fontWeight.medium};
        `,
);

export const ExternalLinkWrapper = styled.a(
    ({ theme: { colors, fontFamily, fontWeight } }) =>
        css`
            color: ${colors.text};
            font-family: ${fontFamily.secondary};
            text-decoration: none;
            margin: 0 4px;
            font-weight: ${fontWeight.medium};
        `,
);
